import RouterView from '@/page/main/DefaultRouterView'

import meetinglist from '@/page/user/meetinglist'
import seallist from '@/page/user/seallist'
import projectlist from '@/page/user/projectlist'
import contractlist from '@/page/user/contractlist'
// import approvalseallist from '@/page/user/approvalseallist'
import approvallist from '@/page/user/approvallist'
import noticeList from '@/page/notice/myList'

import purchaselist from '@/page/user/purchaselist'

export default {
  path: '/User',
  component: RouterView,
  children: [{
      path: 'Meeting/List',
      meta: {
        type: ['user', 'meetinglist'],
        title: "我的会议"
      },
      component: meetinglist
    }, {
      path: 'Seal/List',
      meta: {
        type: ['user', 'seallist'],
        title: "我的印章申请"
      },
      component: seallist
    }, {
      path: 'Project/List',
      meta: {
        type: ['user', 'projectlist'],
        title: "我的工程/项目"
      },
      component: projectlist
    }, {
      path: 'Contract/List',
      meta: {
        type: ['user', 'contractlist'],
        title: "我的合同"
      },
      component: contractlist
    }, {
      path: 'Purchase/List',
      meta: {
        type: ['user', 'purchaselist'],
        title: "我的采购"
      },
      component: purchaselist
    }, {
      path: 'Approval/List',
      meta: {
        type: ['user', 'approvallist'],
        title: "待审批列表"
      },
      component: approvallist
    },
    {
      path: 'Notice/List',
      meta: {
        type: ['user', 'noticelist'],
        title: '我的通知公告'
      },
      component: noticeList
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/user.js